export default __webpack_public_path__ + "static/date-label-dont-3-light-7f2a83ee21faa4fa79aab8d597fc79bf2f013a388764945badb993a6dccb4250.png";